// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"3278":"8b4fe0854296793e7bfb","3564":"30a1da2fed44e5a3c8c1","5664":"506f45448b779fbe990b","7471":"6423b9b898ffefeb7d1d"}[chunkId] + "";
};